import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import WebsiteReasoningPage from '../../features/website-reasoning/components/WebsiteReasoningPage';

const WebsiteReasoningPageRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <WebsiteReasoningPage />
    </ProtectedRoute>
  );
};

export default WebsiteReasoningPageRoute;


